import {Component, ComponentStatus, ComponentStatusValue} from "@/lib/types/statuspages.ts";

export const getComponentStatus = (component: Component, statuses: ComponentStatus[]): ComponentStatus => {
  if (!component.is_group) {
    return statuses.find((s) => s.value === component.status)!;
  }
  if (!component.subcomponents.length) {
    return statuses.find((s) => s.value === ComponentStatusValue.OPERATIONAL)!;
  }

  const rankByStatus = sortComponentStatuses(statuses);
  const keyFn = (x: Component) => rankByStatus[x.status];
  const mostRankedComp = component.subcomponents.slice().sort((a, b) => (keyFn(a) < keyFn(b) ? -1 : 1))[0];
  return statuses.find((s) => s.value === mostRankedComp.status)!;
};

const sortComponentStatuses = (statuses: ComponentStatus[]) => {
  return statuses.reduce((acc: Record<string, number>, s) => {
    acc[s.value] = s.rank;
    return acc;
  }, {});
};
